@if (loadingWrapper.data$|async; as industrialSectors) {
  <div>
    <form [formGroup]="form">
      <ngx-bootstrap-multiselect class="input-sm"
        formControlName="tags"
        [options]="options"
        [texts]="texts"
        [settings]="settings">
      </ngx-bootstrap-multiselect>
    </form>
  </div>
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}

<loading-or-error #loadingOrError [loadingWrapper]="loadingWrapper" [errorMessage]="'Konnte Branchen nicht laden.'">
</loading-or-error>
